import { CompanyServiceProvider } from './types';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { serviceProviderSelectors } from './state';
import { useDebugValue } from 'react';

export type UseCompanyServiceProviderParams = (params: { companyId: string }) => CompanyServiceProvider | null;

export const useServiceProviderById = (companyId: string): CompanyServiceProvider[] => {
  const providers = useSelector<RootState, RootState['serviceProvider']>(state => state.serviceProvider);

  const provider = serviceProviderSelectors.selectAll(providers).filter(p => p.companyId === companyId);

  useDebugValue(provider);

  return provider;
};

export type UsePaymentProvidersByCompanyId = (params: { companyId: string }) => CompanyServiceProvider | null;

export const useServiceProvidersByCompanyId: UsePaymentProvidersByCompanyId = ({ companyId }) => {
  const providers = useSelector<RootState, RootState['serviceProvider']>(state => state.serviceProvider);

  const companyProvider = useSelector<RootState, string>(
    state => state.paymentProviders.companyProviders[companyId] || ''
  );

  const result = serviceProviderSelectors.selectById(providers, companyProvider) || null;

  useDebugValue(result);

  return result;
};
